import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { Http,  URLSearchParams, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';

declare var moment;

@Injectable()
export class CuentasPorPagarService {
  
  private service_url: string;
  private cuenta_por_pagar_url: string;
  private reporte_cxp_url: string;

  constructor(private http: Http, private constantsService: ConstantsService, private validatorService: ValidatorService,
    private authService: AutenticacionService, private errorService:ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/gastos';
    this.cuenta_por_pagar_url = this.constantsService.apiURL + '/cuentas-por-pagar';
    this.reporte_cxp_url = this.constantsService.apiURL + '/reportes/reporte-cuentas-por-pagar';
  }

  public getGastos(filters: any) {
    let myParams = new URLSearchParams();
    
    if(filters.id_proveedor){
      myParams.append('id_proveedor', filters.id_proveedor);
    }

    if(filters.id_obra){
      myParams.append('id_obra', filters.id_obra);
    }

    if(filters.page){
      myParams.append('page', filters.page);
    }

    if(filters.estatusPago){
      myParams.append('estatusPago', filters.estatusPago);
    }

    const options = this.authService.getAuthHeaders();
    options.params = myParams;

    return this.http.get(this.service_url, options);
  } 

  public getGasto(gastoId: number) {;

    const options = this.authService.getAuthHeaders();

    return this.http.get(`${this.service_url}/${gastoId}`, options);
  } 

  public create(gasto : object) {
    return this.http.post(this.service_url , gasto, this.authService.getAuthHeaders());
  }

  public update(gasto : object) {
    return this.http.put(this.service_url , gasto, this.authService.getAuthHeaders());
  }

  public validate(gasto: any){
    let error = [];

    if(!this.validatorService.required(gasto.id_obra)){
        error["id_obra"] = this.errorService.required;
    }

    if(!this.validatorService.required(gasto.id_proveedor)){
        error["id_proveedor"] = this.errorService.required;
    }

    if(!this.validatorService.required(gasto.id_concepto)){
        error["id_concepto"] = this.errorService.required;
    }

    if(!this.validatorService.required(gasto.importe)){
        error["importe"] = this.errorService.required;
    }
    
    if(!this.validatorService.numeric(gasto.importe)){
      error["importe"] = this.errorService.required;
    }

    if(!this.validatorService.required(gasto.fecha_inicio)){
        error["fecha_inicio"] = this.errorService.required;
    }

    //Si es un gasto periodico, aplicamos las validaciones correspondientes
    if(this.validatorService.required(gasto.periodicidad)){
      
      if(!this.validatorService.required(gasto.fecha_fin)){
        error["fecha_fin"] = this.errorService.required;
      }

      //La fecha de termino debe ser mayor a la fecha inicio
      if(this.validatorService.required(gasto.fecha_inicio) && this.validatorService.required(gasto.fecha_fin)){
        //Aunque el input se vea con formato DD/MM/YYYY el datepicker retorna la fecha en formato YYYY-MM-DD
        var fecha_inicio = moment(gasto.fecha_inicio, "YYYY-MM-DD");
        var fecha_fin = moment(gasto.fecha_fin, "YYYY-MM-DD");

        if(fecha_inicio.isAfter(fecha_fin)){
          error['fecha_fin'] = "La fecha de termino debe ser mayor a la fecha inicio";  
        }
      }
    }

    return error;
  }

  /**
   * Servicios de cuentas por pagar 
   */
  public autorizarCuentaPorPagar(id_cuenta_por_pagar: number) {
    return this.http.post(`${this.reporte_cxp_url}/autorizar/${id_cuenta_por_pagar}` , {}, this.authService.getAuthHeaders());
  }

  public listarCuentasPorPagar(filters: any) {
    let myParams = new URLSearchParams();
    
    if(filters.fecha_pago_limite){
      myParams.append('fecha_pago_limite', filters.fecha_pago_limite);
    }

    if(filters.id_obra){
        myParams.append('id_obra', filters.id_obra);
    }

    if(filters.id_proveedor){
      myParams.append('id_proveedor', filters.id_proveedor);
    }

    if(filters.id_concepto){
      myParams.append('id_concepto', filters.id_concepto);
    }

    if(filters.estatus){
      myParams.append('estatus', filters.estatus);
    }

    //Evita que se destruya la llave para los movimientos de tipo sobre
    myParams.append('validarOrigen', 'false');

    let options = this.authService.getAuthHeaders();
    options.params = myParams;

    return this.http.get(this.cuenta_por_pagar_url, options);
  }

  public validarCuentaPorPagar(cuenta: any){
    let error = [];

    if(!this.validatorService.required(cuenta.importe)){
        error["importe"] = this.errorService.required;
    }

    return error;
  }

  public actualizarCuentaPorPagar(cuenta : object) {
    let urlService = `${this.reporte_cxp_url}/cuentas-por-pagar`;

    return this.http.put(urlService , cuenta, this.authService.getAuthHeaders());
  }

  public eliminarCuentaPorPagar(id_cuenta_por_pagar: number) {
    let urlService = `${this.reporte_cxp_url}/cuentas-por-pagar/${id_cuenta_por_pagar}`;
    const options = this.authService.getAuthHeaders();

    return this.http.delete(urlService, options);
  }
  
  public preautorizarCuentaPorPagar(id_cuenta_por_pagar: number) {
    const body = {
      "id_cuenta_por_pagar": id_cuenta_por_pagar
    }
    let urlService = `${this.reporte_cxp_url}/preautorizar`;
    const options = this.authService.getAuthHeaders();

    return this.http.put(urlService, body, options);
  }

  public exportCSV(filters) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    const fecha_pago_limite = filters.fecha_pago_limite;
    const estatus = filters.estatus;
    let fechaInicio_str = "";
    let fechaFin_str = "";
    let id_obra_str = "";
    if (filters.fechaInicio){
      fechaInicio_str = `&fechaInicio=${filters.fechaInicio}`;
    }
    if (filters.fechaFin){
      fechaFin_str = `&fechaFin=${filters.fechaFin}`;
    }
    if (filters.id_obra){
      id_obra_str = `&id_obra=${filters.id_obra}`;
    } 
    let serviceUrl = this.reporte_cxp_url + '/exportar?'+`fecha_pago_limite=${fecha_pago_limite}`
    + `&estatus=${estatus}` + fechaInicio_str + fechaFin_str + id_obra_str;

    return this.http.get(serviceUrl, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }

}


// WEBPACK FOOTER //
// ./src/app/services/cuentas-por-pagar.service.ts